module.exports = __webpack_public_path__ + "img/montre_off.888180af.gif";